import { BaseItem } from '../common';
import {
  BasePrevisitFormTemplateFieldConfig,
  PrevisitFormTemplateFieldConfigWithConditions,
  UpsertCondition,
} from './formTemplateFieldConfig';

export enum Source {
  Ingest = 'INGEST',
  ManualUpdate = 'MANUAL_UPDATE',
  Synced = 'SYNCED',
}

export interface BasePrevisitFormField {
  previsitFormId: string;
  previsitFormSetId: string;
  previsitFormTemplateFieldConfigId: string;
  value: string;
  deleted: boolean;
  deletedTimestamp: Date | null;
  source: Source | null;
}

export interface PrevisitFormField extends BaseItem, BasePrevisitFormField {}

export interface PrevisitFormFieldWithConfig
  extends PrevisitFormField,
    PrevisitFormTemplateFieldConfigWithConditions {}

export interface UpsertValues extends BasePrevisitFormTemplateFieldConfig {
  conditions: UpsertCondition[];
}
